import { useLoaderDataTyped } from "infrastructure/router";
import type { ResourceResponse } from "types";
// import { convertToBooleanSwitch } from "util/transformers";
// import useOnboardingApplication from "features/ecommerce/useOnboardingApplication";
import type { RequestedChangeFileds, WithCompletion, WithOnboardingStep } from "features/ecommerce/types";
import useRequestedChanges from "./useRequestedChanges";

export const useOnboardingStepData = <T extends object>() => {
    // const { isApplicationSubmitted } = useOnboardingApplication();
    const { withRequestedChangeFields } = useRequestedChanges();
    // TODO: This is hack until we get proper backend support for onboarding payment methods step on HR
    let { data, ...rest } = useLoaderDataTyped<ResourceResponse<WithOnboardingStep<T>>>();
    if (!data) {
        data = {
            isIncomplete: 0,
            requestedChangeFields: null,
            methods: '',
            createdAt: "2025-06-17 07:28:49",
            updatedAt: null,
            pki: "30"

        } as any;
    }

    return {
        ...rest,
        data: {
            ...withRequestedChangeFields<WithOnboardingStep<T>, RequestedChangeFileds>(data),
            // isIncomplete: convertToBooleanSwitch(!isApplicationSubmitted())
        }
    } as ResourceResponse<T & WithCompletion>;
};

export default useOnboardingStepData;
